var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-text',{staticStyle:{"height":"100%","padding":"0"}},[_c('div',{staticClass:"chart-container"},[_c('apexchart',{key:_vm.chartKey,attrs:{"type":"line","height":"100%","options":_vm.updatedChartOptions,"series":_vm.sortedSeries}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }